/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useRef, useEffect } from "react";
import { fileTypes, TableController } from "../../../components/Constant";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";
import { useValidationMessages } from "../../../hooks/useValidationMessages";
import { UPLOAD_IMAGE } from "../../../repository/image_upload_repo";
import moment from "moment-timezone";

import { VENDOR_ADD_BANNER, VENDOR_APPROVE_REQUEST, VENDOR_BANNER_LIST, VENDOR_DELETE_BANNER, VENDOR_EDIT_BANNER } from "../../../repository/banner_repo";
import useReduxStore from "../../../hooks/useReduxStore";

export default function useBanner() {

    const { t } = useTranslation();
    const [loader, setLoader] = useState(false)
    const { selector: user } = useReduxStore('auth')
    const { requiredMessage, requiredDate, requiredSelect } = useValidationMessages()
    const [controller, setController] = useState(TableController)
    const [totalCount, setTotalCount] = useState(0);
    const [fileUrl, setFileUrl] = useState(false)
    const [BannerInput, setBannerInput] = useState(
        {
            name: '',
            startDate: '',
            endDate: '',
            image: null
        })

    const [error, setError] = useState({})
    const [openModal, setOpenModal] = useState({
        deleteBanner: false,
        addBanner: false,
        editBanner: false,
        data: null
    })
    
    const [spinner, setSpinner] = useState(false)
    const [imageData, setImageData] = useState('')
    const [filter, setFilter] = useState({
        search: "",
        disable_button: true,
    })
    const [listData, setListData] = useState([])
    const uploadImgRef = useRef(null)
    const fileInputRef = useRef(null);
    const [state, setState] = useState({
        editDropDown: false,
    });
    const [rejectRemark, setRejectRemark] = useState({
        value: "",
        error: ""
    })
    useEffect(() => {
        geteBannerImageList()
    }, [controller])

    const geteBannerImageList = async () => {
        try {
            let payload = {
                count: controller.rowsPerPage,
                page: controller.page,
                isDeleted: false,
                vendor_id: user?.userInfo?._id,
                search: filter.search !== null ?  filter.search : null,
            }
            setSpinner(true)
            let response = await VENDOR_BANNER_LIST(payload)
            setListData(response?.data)
            setTotalCount(response?.totalCount)
        } catch (error) {
            setListData([])
            setTotalCount(0)
        }
        setSpinner(false)
    }

    const handleInputChange = async (e) => {
        const { name, value } = e.target;
        setBannerInput((pre) => ({ ...pre, [name]: value }))
        setError((pre) => {
            delete pre[name];
            return { ...pre };
        });
    }
   const HandleSearch = () => {
        setController((pre) => ({ ...pre, searchPage: pre?.page, page: 1 }))
    }
    const getDetails = async (data) => {
        setBannerInput((prev) => ({
            ...prev,
            categoryName: data?.categoryName || '',
            image: data?.image || null,
        }));

    }
    const handleBlur = (event) => {
        const { name, value } = event.target
        !value?.trim()?.length && setError((pre) => ({ ...pre, [name]: errorMessage[name] }))
    }
    const clearForm = () => {
        setBannerInput({ categoryName: '', image: null, })
        setError({})

    }
    const errorMessage = {
        categoryName: requiredMessage(t(`${t("formTitle.eventCategory").toLowerCase()} ${t("formTitle.name").toLowerCase()}`)),
    }
     const reset = () => {
        setController((pre) => ({ ...pre, page: pre.searchPage ?? pre.page, searchPage: null, }))
        setFilter((prev) => ({ ...prev, search: "", disable_button: true }))
    }
    // Error hendling
    const isValid = () => {
        const errorObj = {};

        if (!BannerInput?.name?.trim()) {
            errorObj['name'] = requiredMessage(t(`${t("validation.name")} `));
        }

        if (!BannerInput?.startDate) {
            errorObj['startDate'] = requiredDate(t(`${t("validation.startDate")} `));
        }

        if (!BannerInput?.endDate) {
            errorObj['endDate'] = requiredDate(t(`${t("validation.endDate")} `));
        }

        if (BannerInput?.startDate && BannerInput?.endDate) {
            const start = new Date(BannerInput.startDate);
            const end = new Date(BannerInput.endDate);

            if (end < start) {
                errorObj['endDate'] = requiredMessage(t(`${t("validation.greaterEndDate")} `));
            }
        }

        if (!BannerInput?.image) {
            errorObj['image'] = requiredSelect(t(`${t("tableTitle.image")} `));
        }

        setError(errorObj);
        return Object.keys(errorObj).length === 0; // Returns `true` if no errors
    };
  const handleChangeFilter = (event, disable = false) => {
        const { name, value } = event.target
        setFilter((pre) => ({ ...pre, disable_button: disable, [name]: value }))
    }
    const handleApprove = async (bannerId = null) => {
        let payload = {
            vendor_id: user?.userInfo?._id,
            id:bannerId,
            status: "Accepted"
        }
        setLoader(true)
        try {
            let response = await VENDOR_APPROVE_REQUEST(payload)
            geteBannerImageList()
            toast.success(response.message)
            setLoader(false)
        } catch (error) {
            toast.error(error.message);
            setLoader(false)
        }
    }
     const handleReject = async () => {
        if (!rejectRemark?.value?.trim()) {
            setRejectRemark((prev) => ({ ...prev, error: requiredMessage(`${t("validation.reason")}`) }))
            return
        }
        setLoader(true)
        const payload = {
             vendor_id: user?.userInfo?._id,
            id: openModal.data?._id,
            cancelReason: rejectRemark?.value,
            status: "Cancel",
        }
        try {
            let response = await VENDOR_APPROVE_REQUEST(payload)
            toast.success(response.message)
            geteBannerImageList()
            setLoader(false)
            handleClosedModal("reject")
            setRejectRemark((prev) => ({ ...prev, value: "" }))
        } catch (error) {
            toast.error(error.message);
            setLoader(false)
        }
    }

    const handleEditCategory = () => {
        setState(prev => ({ ...prev, editDropDown: !prev.editDropDown }));
    }
    const TableHeadData = [
        { label: '#' },
        { label: `${t("tableTitle.image")}` },
        { label: `${t("tableTitle.name")}` },
        { label: `${t("formTitle.startDate")}` },
        { label: `${t("formTitle.endDate")}` },
        { label: `${t('buttonTitle.approve')} ${t('tableTitle.status')}` },
        { label: `${t("tableTitle.action")}` },
    ]

    const handleOpenModal = (type, data = null) => {
        if (type === "addBanner" && data) {
            setBannerInput((prev) => ({
                ...prev,
                name: data?.name,
                startDate: new Date(data?.startDate),
                endDate: new Date(data?.endDate),
                image: data?.image,
            }));
            setError({})

        }
        setOpenModal((prev) => ({

            ...prev,
            data: data,
            [type]: true,
        }));
    };
    const handleClosedModal = (type) => {
        if (type === "addBanner") {
            clearForm()
        }
        setOpenModal((pre) => ({
            ...pre,
            data: null,
            [type]: false
        }))
        setState({
            editDropDown: false,
        })
    }

    const handlePagination = (obj) => {
        setController(obj)
    }
    const clear = () => {
        setBannerInput({
            startDate: null,
            endDate: null,
            image: null,
            name: '',
            
        });
    }
    const handleAddSubmit = async (event) => {
        event.preventDefault()
        if (!isValid()) return
        setSpinner(true)
        let payload = {
            vendor_id: user?.userInfo?._id,
            startDate: moment(BannerInput?.startDate),
            endDate: moment(BannerInput?.endDate),
            image: BannerInput?.image,
            name: BannerInput?.name,
            id: openModal.data?._id,
        }
        try {
            let response = openModal.data ? await VENDOR_EDIT_BANNER(payload) : await VENDOR_ADD_BANNER(payload)
            handleClosedModal('addBanner')
            setSpinner(false)
            geteBannerImageList()
            toast.success(response.message)
            clear()
        } catch (error) {
            toast.error(error.message)
            setSpinner(false)
        }

    }


    const uploadBanner = async (file) => {
        if (!file) return;

        const isImage = fileTypes.Img_Type.includes(file.type);
        const isVideo = fileTypes.video_Type.includes(file.type);

        if (!isImage && !isVideo) {
            toast(`${t("validation.imageAndVideo")}`);
            return;
        }

        const fd = new FormData();
        fd.append('type', "BANNER");
        fd.append('files', file);

        setSpinner(true);

        try {
            const response = await UPLOAD_IMAGE(fd);
            const uploadedName = response?.data?.[0]?.db_name;

            setBannerInput((prev) => ({
                ...prev,
                image: uploadedName,
            }));

            setError((prev) => {
                delete prev["image"];
                return { ...prev };
            });
        } catch (error) {
            toast.error(error.message);
        }

        setSpinner(false);
        if (uploadImgRef.current) uploadImgRef.current.value = "";
    };


    const handleDelete = async (event) => {
        if (event === "YES") {
            setSpinner(true)
            const payload = {
                id: openModal.data?._id,
                isDeleted: !openModal.data?.isDeleted
            }
            try {
                let response = await VENDOR_DELETE_BANNER(payload)
                toast.success(response.message)
                // if (geteBannerImageList?.length === 1 && controller.page === 1) geteBannerImageList()
                // else if (geteBannerImageList?.length === 1) setController((pre) => ({ ...pre, page: controller.page > 1 ? controller.page - 1 : 1 }))
                // else geteBannerImageList()
                if (listData?.length === 1 && controller.page > 1) {
                 setController((prev) => ({ ...prev, page: prev.page - 1 }))
                } else {
                 geteBannerImageList()
                }
                setSpinner(false)
                handleClosedModal("deleteBanner")
            } catch (error) {
                toast.error(error.message);
                setSpinner(false)
            }

        } else {
            handleClosedModal("deleteBanner")
        }
    }


    return {
        methods: {
            setTotalCount,
            handlePagination,
            handleClosedModal,
            handleOpenModal,
            handleEditCategory,
            setFileUrl,
            handleInputChange,
            handleBlur,
            handleAddSubmit,
            setImageData,
            setSpinner,
            setFilter,
            handleDelete,
            getDetails,
            uploadBanner,
            setBannerInput,
            clear,
            HandleSearch,handleChangeFilter,
            handleApprove,
            handleReject,reset,
            setRejectRemark,
        },
        data: {
            TableHeadData,
            controller,
            totalCount,
            openModal,
            state,
            fileUrl,
            uploadImgRef,
            BannerInput,
            error,
            spinner,
            fileInputRef,
            imageData,
            listData,
            filter,
            rejectRemark,

        },
    }
}
